import $ from 'jquery';
import axios from 'axios';
import {submit as submit_neosafe_login_form_handler} from "./form/login.js";
import {submit as submit_neosafe_forgot_password_form_handler} from "./form/forgot.js";
import {submit as submit_neosafe_reset_password_form_handler} from "./form/reset.js";

const init_neosafe_api = () => {
    axios.defaults.baseURL = ajax_data.root_rest;
    axios.defaults.headers.common['X-WP-Nonce'] = ajax_data.nounce_neosafe;


    $('form.neosafe-login-form').on('submit', (e) => submit_neosafe_login_form_handler(e))
    $('form.neosafe-forgot-password-form').on('submit', (e) => submit_neosafe_forgot_password_form_handler(e))
    $('form.neosafe-reset-password-form').on('submit', (e) => submit_neosafe_reset_password_form_handler(e))
}

export {init_neosafe_api};
